<template>
  <div class="event__details-main">
    <div class="row y-gap-30">
      <div class="pt-40">
        <img src="../../assets/images/home/event-1.png" class="rounded-8 img-fluid" alt="event image" width="793"
          height="448" />
      </div>

      <div class="event-tabs">
        <div>
          <a href="#" :class="[
            'fw-600',
            'text-16',
            'text-secondary',
            'capitalize',
            { active: activeTab === 'overview' },
          ]" @click.prevent="setActiveTab('overview')">
            overview
          </a>
        </div>

        <div>
          <a href="#" :class="[
            'fw-600',
            'text-16',
            'text-secondary',
            'capitalize',
            { active: activeTab === 'requirements' },
          ]" @click.prevent="setActiveTab('requirements')">
            Requirements
          </a>
        </div>

        <div>
          <a href="#" :class="[
            'fw-600',
            'text-16',
            'text-secondary',
            'capitalize',
            { active: activeTab === 'curriculum' },
          ]" @click.prevent="setActiveTab('curriculum')">
            curriculum
          </a>
        </div>

        <div>
          <a href="#" :class="[
            'fw-600',
            'text-16',
            'text-secondary',
            'capitalize',
            { active: activeTab === 'target' },
          ]" @click.prevent="setActiveTab('target')">
            Who This Course For
          </a>
        </div>
      </div>
      <!----------start of tabs-->
      <section class="px-35 tabs-container">
        <!----start of overview--------->
        <div id="overview" class="pt-40 lg:pt-40 to-over">
          <div>
            <h4 class="text-24 fw-600 capitalize">Description</h4>
            <p class="fw-400 mt-15">
              Phasellus enim magna, varius et commodo ut, ultricies vitae velit.
              Ut nulla tellus, eleifend euismod pellentesque vel, sagittis vel
              justo. In libero urna, venenatis sit amet ornare non, suscipit nec
              risus. Sed consequat justo non mauris pretium at tempor justo
              sodales. Quisque tincidunt laoreet malesuada. Cum sociis natoque
              penatibus et magnis dis parturient montes, nascetur.
              <br />
              <br />
              First, we will go over the differences between UX and UI Design.
              We will look at what our brief for this real-world project is,
              then we will learn about low-fidelity wireframes and how to make
              use of existing UI design kits.
            </p>
          </div>
          <!---what you will learn---------->
          <div class="mt-30">
            <h4 class="text-24 fw-600 capitalize pt-15">What you'll learn</h4>
            <p class="mt-15 mb-20">
              Discover the Skills and Knowledge You'll Acquire by Completing
              This Course
            </p>
            <div class="row x-gap-100 justfiy-between learn pb-30">
              <div class="y-gap-20">
                <div class="d-flex items-center">
                  <div class="d-flex justify-center items-center border-light rounded-full size-20 mr-10 rotate-svg">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="16" viewBox="0 0 21 16" fill="none">
                      <path
                        d="M10.9997 16.0001C10.1987 16.0001 9.44473 15.6881 8.87873 15.1211C8.31273 14.5541 7.99873 13.8001 7.99973 12.9981C7.99973 12.2521 8.27073 12.0001 8.76373 11.0001H3.92773C2.27373 11.0001 0.927734 9.65306 0.927734 8.00006C0.927734 6.34706 2.27373 5.00006 3.92773 5.00006H8.76373C8.26973 4.00006 7.99973 3.74506 7.99973 2.99906C7.99885 2.60489 8.07618 2.21447 8.22723 1.85039C8.37829 1.48632 8.60007 1.15583 8.87973 0.878058C10.0117 -0.253942 11.9877 -0.254941 13.1207 0.879059L20.2417 8.00006L13.1207 15.1211C12.8429 15.4005 12.5124 15.6221 12.1483 15.773C11.7842 15.9239 11.3938 16.0011 10.9997 16.0001ZM3.92773 7.00006C3.67025 7.01158 3.42714 7.12196 3.24901 7.30824C3.07088 7.49452 2.97147 7.74232 2.97147 8.00006C2.97147 8.2578 3.07088 8.5056 3.24901 8.69188C3.42714 8.87815 3.67025 8.98854 3.92773 9.00006H13.5857L10.2927 12.2931C10.1054 12.4803 10.0001 12.7342 9.99973 12.9991C9.99973 13.2681 10.1037 13.5181 10.2927 13.7071C10.4831 13.8891 10.7363 13.9907 10.9997 13.9907C11.2631 13.9907 11.5164 13.8891 11.7067 13.7071L17.4137 8.00006L11.7067 2.29306C11.5164 2.11103 11.2631 2.00944 10.9997 2.00944C10.7363 2.00944 10.4831 2.11103 10.2927 2.29306C10.1054 2.48031 10.0001 2.73421 9.99973 2.99906C9.99973 3.26706 10.1037 3.51806 10.2927 3.70706L13.5857 7.00006H3.92773Z"
                        fill="#09445D" />
                    </svg>
                  </div>
                  <p class="fw-500">Learn new concepts from industry experts</p>
                </div>

                <div class="d-flex items-center">
                  <div class="d-flex justify-center items-center border-light rounded-full size-20 mr-10 rotate-svg">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="16" viewBox="0 0 21 16" fill="none">
                      <path
                        d="M10.9997 16.0001C10.1987 16.0001 9.44473 15.6881 8.87873 15.1211C8.31273 14.5541 7.99873 13.8001 7.99973 12.9981C7.99973 12.2521 8.27073 12.0001 8.76373 11.0001H3.92773C2.27373 11.0001 0.927734 9.65306 0.927734 8.00006C0.927734 6.34706 2.27373 5.00006 3.92773 5.00006H8.76373C8.26973 4.00006 7.99973 3.74506 7.99973 2.99906C7.99885 2.60489 8.07618 2.21447 8.22723 1.85039C8.37829 1.48632 8.60007 1.15583 8.87973 0.878058C10.0117 -0.253942 11.9877 -0.254941 13.1207 0.879059L20.2417 8.00006L13.1207 15.1211C12.8429 15.4005 12.5124 15.6221 12.1483 15.773C11.7842 15.9239 11.3938 16.0011 10.9997 16.0001ZM3.92773 7.00006C3.67025 7.01158 3.42714 7.12196 3.24901 7.30824C3.07088 7.49452 2.97147 7.74232 2.97147 8.00006C2.97147 8.2578 3.07088 8.5056 3.24901 8.69188C3.42714 8.87815 3.67025 8.98854 3.92773 9.00006H13.5857L10.2927 12.2931C10.1054 12.4803 10.0001 12.7342 9.99973 12.9991C9.99973 13.2681 10.1037 13.5181 10.2927 13.7071C10.4831 13.8891 10.7363 13.9907 10.9997 13.9907C11.2631 13.9907 11.5164 13.8891 11.7067 13.7071L17.4137 8.00006L11.7067 2.29306C11.5164 2.11103 11.2631 2.00944 10.9997 2.00944C10.7363 2.00944 10.4831 2.11103 10.2927 2.29306C10.1054 2.48031 10.0001 2.73421 9.99973 2.99906C9.99973 3.26706 10.1037 3.51806 10.2927 3.70706L13.5857 7.00006H3.92773Z"
                        fill="#09445D" />
                    </svg>
                  </div>
                  <p class="fw-500">
                    Gain a foundational understanding of a subject or tool
                  </p>
                </div>

                <div class="d-flex items-center">
                  <div class="d-flex justify-center items-center border-light rounded-full size-20 mr-10 rotate-svg">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="16" viewBox="0 0 21 16" fill="none">
                      <path
                        d="M10.9997 16.0001C10.1987 16.0001 9.44473 15.6881 8.87873 15.1211C8.31273 14.5541 7.99873 13.8001 7.99973 12.9981C7.99973 12.2521 8.27073 12.0001 8.76373 11.0001H3.92773C2.27373 11.0001 0.927734 9.65306 0.927734 8.00006C0.927734 6.34706 2.27373 5.00006 3.92773 5.00006H8.76373C8.26973 4.00006 7.99973 3.74506 7.99973 2.99906C7.99885 2.60489 8.07618 2.21447 8.22723 1.85039C8.37829 1.48632 8.60007 1.15583 8.87973 0.878058C10.0117 -0.253942 11.9877 -0.254941 13.1207 0.879059L20.2417 8.00006L13.1207 15.1211C12.8429 15.4005 12.5124 15.6221 12.1483 15.773C11.7842 15.9239 11.3938 16.0011 10.9997 16.0001ZM3.92773 7.00006C3.67025 7.01158 3.42714 7.12196 3.24901 7.30824C3.07088 7.49452 2.97147 7.74232 2.97147 8.00006C2.97147 8.2578 3.07088 8.5056 3.24901 8.69188C3.42714 8.87815 3.67025 8.98854 3.92773 9.00006H13.5857L10.2927 12.2931C10.1054 12.4803 10.0001 12.7342 9.99973 12.9991C9.99973 13.2681 10.1037 13.5181 10.2927 13.7071C10.4831 13.8891 10.7363 13.9907 10.9997 13.9907C11.2631 13.9907 11.5164 13.8891 11.7067 13.7071L17.4137 8.00006L11.7067 2.29306C11.5164 2.11103 11.2631 2.00944 10.9997 2.00944C10.7363 2.00944 10.4831 2.11103 10.2927 2.29306C10.1054 2.48031 10.0001 2.73421 9.99973 2.99906C9.99973 3.26706 10.1037 3.51806 10.2927 3.70706L13.5857 7.00006H3.92773Z"
                        fill="#09445D" />
                    </svg>
                  </div>
                  <p class="fw-500">
                    Develop job-relevant skills with hands-on projects
                  </p>
                </div>

                <div class="d-flex items-center">
                  <div class="d-flex justify-center items-center border-light rounded-full size-20 mr-10 rotate-svg">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="16" viewBox="0 0 21 16" fill="none">
                      <path
                        d="M10.9997 16.0001C10.1987 16.0001 9.44473 15.6881 8.87873 15.1211C8.31273 14.5541 7.99873 13.8001 7.99973 12.9981C7.99973 12.2521 8.27073 12.0001 8.76373 11.0001H3.92773C2.27373 11.0001 0.927734 9.65306 0.927734 8.00006C0.927734 6.34706 2.27373 5.00006 3.92773 5.00006H8.76373C8.26973 4.00006 7.99973 3.74506 7.99973 2.99906C7.99885 2.60489 8.07618 2.21447 8.22723 1.85039C8.37829 1.48632 8.60007 1.15583 8.87973 0.878058C10.0117 -0.253942 11.9877 -0.254941 13.1207 0.879059L20.2417 8.00006L13.1207 15.1211C12.8429 15.4005 12.5124 15.6221 12.1483 15.773C11.7842 15.9239 11.3938 16.0011 10.9997 16.0001ZM3.92773 7.00006C3.67025 7.01158 3.42714 7.12196 3.24901 7.30824C3.07088 7.49452 2.97147 7.74232 2.97147 8.00006C2.97147 8.2578 3.07088 8.5056 3.24901 8.69188C3.42714 8.87815 3.67025 8.98854 3.92773 9.00006H13.5857L10.2927 12.2931C10.1054 12.4803 10.0001 12.7342 9.99973 12.9991C9.99973 13.2681 10.1037 13.5181 10.2927 13.7071C10.4831 13.8891 10.7363 13.9907 10.9997 13.9907C11.2631 13.9907 11.5164 13.8891 11.7067 13.7071L17.4137 8.00006L11.7067 2.29306C11.5164 2.11103 11.2631 2.00944 10.9997 2.00944C10.7363 2.00944 10.4831 2.11103 10.2927 2.29306C10.1054 2.48031 10.0001 2.73421 9.99973 2.99906C9.99973 3.26706 10.1037 3.51806 10.2927 3.70706L13.5857 7.00006H3.92773Z"
                        fill="#09445D" />
                    </svg>
                  </div>
                  <p class="fw-500">Earn a shareable career certificate</p>
                </div>
              </div>
            </div>
          </div>
          <!-----instractor data---------->
          <div class="event-instractor">
            <h4 class="text-24 fw-600 capitalize pt-15 mb-30">
              About Instructor
            </h4>

            <ul class="comments__list">
              <li class="comments__item">
                <div class="comments__item-inner d-flex gap-10">
                  <div class="comments__img">
                    <img src="../../assets/images/home/insteractor.png" alt="image" width="145" height="145" />
                  </div>

                  <div class="comments__body md:mt-15">
                    <div class="comments__header">
                      <h4 class="text-24 fw-700 lh-15 mt-0">Ali Katary</h4>
                      <span class="text-16 text-light-1 fw-400">Expert Engineer, +8yr Experience at primavera.</span>
                      <div class="stars d-flex gap-10">
                        <div>
                          <rating-component :rating="3.5" />
                        </div>

                        <!----<div class="fw-400">(1.2K)</div>-->
                      </div>
                    </div>
                  </div>
                </div>
                <!---instractor description--->
                <div class="comments__text mt-25 mb-24">
                  <p class="fw-400 text-16">
                    This course is a very applicable. Professor Ng explains
                    precisely each algorithm and even tries to give an intuition
                    for mathematical and statistic concepts behind each
                    algorithm. Thank you very much.
                  </p>
                  <p class="fw-400 text-16">
                    This course is a very applicable. Professor Ng explains
                    precisely each algorithm and even tries to give an intuition
                    for mathematical and statistic concepts behind each
                    algorithm. Thank you very much.
                  </p>
                </div>
                <!--------------->
                <div class="instractor-social mt-30 mb-40 pb-40">
                  <div class="d-flex ms-auto justify-content-end">
                    <a href="#" aria-label="facebook account">
                      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                        <path
                          d="M5.38184 15.9179C5.38244 18.458 6.289 20.9145 7.9386 22.8461C9.58819 24.7776 11.8726 26.0574 14.3813 26.4555V19.0006H11.6752V15.9179H14.3845V13.5712C14.3247 13.022 14.3865 12.4663 14.5656 11.9437C14.7448 11.421 15.0368 10.9442 15.4209 10.5472C15.8051 10.1501 16.2719 9.84247 16.7884 9.64615C17.3048 9.44983 17.8581 9.36963 18.409 9.41124C19.209 9.42404 20.009 9.49551 20.7984 9.62458V12.2475H19.4501C19.221 12.2175 18.988 12.2394 18.7684 12.3115C18.5489 12.3836 18.3483 12.5042 18.1816 12.6642C18.0149 12.8243 17.8863 13.0198 17.8053 13.2362C17.7242 13.4526 17.6929 13.6845 17.7136 13.9147V15.9179H20.6693L20.1968 19.0016H17.7136V26.4555C19.727 26.1373 21.6072 25.2488 23.1313 23.8953C24.6555 22.5417 25.7599 20.7797 26.3138 18.818C26.8677 16.8562 26.8479 14.7768 26.2567 12.826C25.6655 10.8752 24.5277 9.13458 22.978 7.81033C21.4282 6.48608 19.5315 5.63361 17.5124 5.35386C15.4932 5.07411 13.4362 5.37879 11.5848 6.23183C9.73339 7.08487 8.16521 8.45055 7.06589 10.1672C5.96658 11.8838 5.38216 13.8795 5.38184 15.9179Z"
                          fill="#0E658B" />
                      </svg>
                    </a>
                    <a href="#" aria-label="linked in account">
                      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                        <path
                          d="M22.8149 8.00049H9.18111C8.52911 8.00049 8 8.51715 8 9.15338V22.846C8 23.4832 8.52911 24.0005 9.18111 24.0005H22.8149C23.4673 24.0005 24 23.4832 24 22.846V9.15338C24 8.51715 23.4673 8.00049 22.8149 8.00049ZM12.7453 21.6347H10.3711V13.9994H12.7453V21.6347ZM11.5582 12.9554C11.3775 12.9554 11.1986 12.9198 11.0316 12.8506C10.8647 12.7814 10.713 12.68 10.5852 12.5522C10.4575 12.4243 10.3562 12.2726 10.2871 12.1056C10.218 11.9386 10.1826 11.7596 10.1827 11.5789C10.1827 11.2141 10.3276 10.8643 10.5855 10.6063C10.8435 10.3484 11.1933 10.2035 11.5581 10.2035C11.9229 10.2035 12.2728 10.3484 12.5307 10.6063C12.7886 10.8643 12.9336 11.2141 12.9336 11.5789C12.9336 11.9438 12.7887 12.2937 12.5308 12.5518C12.2729 12.8099 11.9231 12.9551 11.5582 12.9554ZM21.6333 21.6347H19.2629V17.9218C19.2629 17.036 19.2456 15.8972 18.0293 15.8972C16.7942 15.8972 16.606 16.8618 16.606 17.8576V21.6349H14.2338V13.9994H16.5104V15.042H16.5429C16.8598 14.442 17.634 13.8089 18.7887 13.8089C21.19 13.8089 21.6336 15.3898 21.6336 17.4465L21.6333 21.6347Z"
                          fill="#0E658B" />
                      </svg>
                    </a>
                    <a href="#" aria-label="twitter account">
                      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                        <path
                          d="M26.6927 9.62593C26.1081 10.4969 25.3683 11.2725 24.5093 11.8929C24.5212 12.0719 24.5212 12.2628 24.5212 12.4537C24.5212 18.2404 20.1185 24.91 12.0768 24.91C9.60695 24.91 7.30419 24.1822 5.35938 22.9414C5.70539 22.9772 6.0514 23.001 6.40934 23.001C8.46154 23.001 10.3467 22.2971 11.8381 21.1278C10.9258 21.1089 10.0421 20.8056 9.31055 20.2601C8.57898 19.7146 8.03605 18.9543 7.75759 18.0853C8.02008 18.133 8.2945 18.1688 8.58085 18.1688C8.97459 18.1688 9.36832 18.1091 9.72626 18.0137C8.73668 17.8106 7.84741 17.2724 7.20841 16.4899C6.5694 15.7075 6.21976 14.7286 6.21844 13.7184V13.6707C6.81501 13.9928 7.48316 14.1957 8.19905 14.2195C7.59986 13.8176 7.10895 13.2742 6.76974 12.6374C6.43053 12.0006 6.25347 11.29 6.25423 10.5685C6.25423 9.76911 6.46899 9.01743 6.8508 8.37313C9.01038 11.0219 12.2319 12.7639 15.8709 12.9429C15.7993 12.6207 15.7516 12.2866 15.7516 11.9406C15.7548 10.7814 16.2175 9.67065 17.0384 8.85204C17.8592 8.03343 18.9712 7.57373 20.1304 7.57373C21.3952 7.57373 22.5287 8.09871 23.3281 8.95777C24.3184 8.75494 25.2609 8.397 26.1081 7.89588C25.774 8.91005 25.082 9.76911 24.1752 10.306C25.0445 10.211 25.8938 9.98157 26.6927 9.62593Z"
                          fill="#0E658B" />
                      </svg>
                    </a>
                    <a href="#" aria-label="youtube channel">
                      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                        <path
                          d="M26.2333 10.8809C26.1119 10.4305 25.8747 10.0197 25.5451 9.68942C25.2156 9.35916 24.8054 9.12096 24.3552 8.99853C22.686 8.54018 16.008 8.53272 16.008 8.53272C16.008 8.53272 9.33116 8.52526 7.66087 8.96335C7.21098 9.09142 6.80156 9.33299 6.47192 9.66487C6.14228 9.99674 5.90349 10.4078 5.77847 10.8585C5.33825 12.5278 5.33399 15.9898 5.33399 15.9898C5.33399 15.9898 5.32972 19.469 5.76675 21.1212C6.01191 22.0346 6.7314 22.7563 7.64595 23.0025C9.33222 23.4608 15.992 23.4683 15.992 23.4683C15.992 23.4683 22.67 23.4758 24.3392 23.0387C24.7896 22.9165 25.2002 22.6789 25.5305 22.3493C25.8609 22.0197 26.0994 21.6096 26.2227 21.1595C26.664 19.4914 26.6672 16.0304 26.6672 16.0304C26.6672 16.0304 26.6885 12.5501 26.2333 10.8809ZM13.8719 19.1972L13.8773 12.8017L19.4275 16.0048L13.8719 19.1972Z"
                          fill="#0E658B" />
                      </svg>
                    </a>
                    <a href="#" aria-label="instagram account">
                      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                        <path
                          d="M26.7256 11.5981C26.7136 10.7009 26.5457 9.81259 26.2292 8.97294C25.9548 8.26469 25.5356 7.62147 24.9985 7.08439C24.4614 6.5473 23.8182 6.12816 23.11 5.85373C22.2811 5.54259 21.4055 5.37435 20.5203 5.35617C19.3807 5.30523 19.0194 5.29102 16.1264 5.29102C13.2335 5.29102 12.8627 5.29102 11.7313 5.35617C10.8466 5.37448 9.97135 5.54272 9.14286 5.85373C8.4345 6.12796 7.79119 6.54704 7.25408 7.08415C6.71697 7.62126 6.29789 8.26458 6.02365 8.97294C5.71188 9.80117 5.54401 10.6766 5.52728 11.5614C5.47634 12.7022 5.46094 13.0636 5.46094 15.9565C5.46094 18.8494 5.46094 19.219 5.52728 20.3516C5.54505 21.2377 5.71209 22.112 6.02365 22.9424C6.29835 23.6506 6.71774 24.2936 7.25503 24.8305C7.79232 25.3674 8.43569 25.7863 9.14404 26.0605C9.97026 26.3841 10.8457 26.5644 11.7325 26.5935C12.8733 26.6445 13.2347 26.6599 16.1276 26.6599C19.0205 26.6599 19.3913 26.6599 20.5227 26.5935C21.4078 26.5761 22.2835 26.4083 23.1124 26.0972C23.8204 25.8224 24.4635 25.4032 25.0005 24.8661C25.5376 24.3291 25.9568 23.686 26.2316 22.978C26.5431 22.1487 26.7102 21.2744 26.7279 20.3871C26.7789 19.2475 26.7943 18.8862 26.7943 15.992C26.7919 13.0991 26.7919 12.7319 26.7256 11.5981ZM16.1193 21.4273C13.0937 21.4273 10.6426 18.9762 10.6426 15.9506C10.6426 12.925 13.0937 10.4739 16.1193 10.4739C17.5718 10.4739 18.9648 11.0509 19.9919 12.078C21.019 13.1051 21.596 14.4981 21.596 15.9506C21.596 17.4031 21.019 18.7961 19.9919 19.8232C18.9648 20.8502 17.5718 21.4273 16.1193 21.4273ZM21.814 11.5484C21.6462 11.5485 21.4801 11.5156 21.3251 11.4515C21.1701 11.3874 21.0292 11.2933 20.9106 11.1747C20.792 11.0561 20.6979 10.9152 20.6338 10.7602C20.5697 10.6052 20.5367 10.4391 20.5369 10.2713C20.5369 10.1037 20.5699 9.93771 20.6341 9.78284C20.6982 9.62797 20.7922 9.48725 20.9108 9.36872C21.0293 9.25019 21.17 9.15617 21.3249 9.09202C21.4798 9.02787 21.6457 8.99485 21.8134 8.99485C21.981 8.99485 22.147 9.02787 22.3019 9.09202C22.4567 9.15617 22.5974 9.25019 22.716 9.36872C22.8345 9.48725 22.9285 9.62797 22.9927 9.78284C23.0568 9.93771 23.0898 10.1037 23.0898 10.2713C23.0898 10.9774 22.5188 11.5484 21.814 11.5484Z"
                          fill="#0E658B" />
                        <path
                          d="M16.1191 19.5076C18.0838 19.5076 19.6766 17.9149 19.6766 15.9501C19.6766 13.9853 18.0838 12.3926 16.1191 12.3926C14.1543 12.3926 12.5615 13.9853 12.5615 15.9501C12.5615 17.9149 14.1543 19.5076 16.1191 19.5076Z"
                          fill="#0E658B" />
                      </svg>
                    </a>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <!-----instractor data---------->
        </div>
        <!----->
        <!----start of overview--------->
        <div id="requirements" class="pt-50">
          <div>
            <h4 class="text-24 fw-600 capitalize pt-15 mb-25">requirements</h4>
            <div class="row x-gap-100 justfiy-between learn pb-40">
              <div class="y-gap-20">
                <div class="d-flex items-center">
                  <div class="d-flex justify-center items-center border-light rounded-full size-20 mr-10 rotate-svg">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="16" viewBox="0 0 21 16" fill="none">
                      <path
                        d="M10.9997 16.0001C10.1987 16.0001 9.44473 15.6881 8.87873 15.1211C8.31273 14.5541 7.99873 13.8001 7.99973 12.9981C7.99973 12.2521 8.27073 12.0001 8.76373 11.0001H3.92773C2.27373 11.0001 0.927734 9.65306 0.927734 8.00006C0.927734 6.34706 2.27373 5.00006 3.92773 5.00006H8.76373C8.26973 4.00006 7.99973 3.74506 7.99973 2.99906C7.99885 2.60489 8.07618 2.21447 8.22723 1.85039C8.37829 1.48632 8.60007 1.15583 8.87973 0.878058C10.0117 -0.253942 11.9877 -0.254941 13.1207 0.879059L20.2417 8.00006L13.1207 15.1211C12.8429 15.4005 12.5124 15.6221 12.1483 15.773C11.7842 15.9239 11.3938 16.0011 10.9997 16.0001ZM3.92773 7.00006C3.67025 7.01158 3.42714 7.12196 3.24901 7.30824C3.07088 7.49452 2.97147 7.74232 2.97147 8.00006C2.97147 8.2578 3.07088 8.5056 3.24901 8.69188C3.42714 8.87815 3.67025 8.98854 3.92773 9.00006H13.5857L10.2927 12.2931C10.1054 12.4803 10.0001 12.7342 9.99973 12.9991C9.99973 13.2681 10.1037 13.5181 10.2927 13.7071C10.4831 13.8891 10.7363 13.9907 10.9997 13.9907C11.2631 13.9907 11.5164 13.8891 11.7067 13.7071L17.4137 8.00006L11.7067 2.29306C11.5164 2.11103 11.2631 2.00944 10.9997 2.00944C10.7363 2.00944 10.4831 2.11103 10.2927 2.29306C10.1054 2.48031 10.0001 2.73421 9.99973 2.99906C9.99973 3.26706 10.1037 3.51806 10.2927 3.70706L13.5857 7.00006H3.92773Z"
                        fill="#09445D" />
                    </svg>
                  </div>
                  <p class="fw-500">Primavera P6</p>
                </div>

                <div class="d-flex items-center">
                  <div class="d-flex justify-center items-center border-light rounded-full size-20 mr-10 rotate-svg">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="16" viewBox="0 0 21 16" fill="none">
                      <path
                        d="M10.9997 16.0001C10.1987 16.0001 9.44473 15.6881 8.87873 15.1211C8.31273 14.5541 7.99873 13.8001 7.99973 12.9981C7.99973 12.2521 8.27073 12.0001 8.76373 11.0001H3.92773C2.27373 11.0001 0.927734 9.65306 0.927734 8.00006C0.927734 6.34706 2.27373 5.00006 3.92773 5.00006H8.76373C8.26973 4.00006 7.99973 3.74506 7.99973 2.99906C7.99885 2.60489 8.07618 2.21447 8.22723 1.85039C8.37829 1.48632 8.60007 1.15583 8.87973 0.878058C10.0117 -0.253942 11.9877 -0.254941 13.1207 0.879059L20.2417 8.00006L13.1207 15.1211C12.8429 15.4005 12.5124 15.6221 12.1483 15.773C11.7842 15.9239 11.3938 16.0011 10.9997 16.0001ZM3.92773 7.00006C3.67025 7.01158 3.42714 7.12196 3.24901 7.30824C3.07088 7.49452 2.97147 7.74232 2.97147 8.00006C2.97147 8.2578 3.07088 8.5056 3.24901 8.69188C3.42714 8.87815 3.67025 8.98854 3.92773 9.00006H13.5857L10.2927 12.2931C10.1054 12.4803 10.0001 12.7342 9.99973 12.9991C9.99973 13.2681 10.1037 13.5181 10.2927 13.7071C10.4831 13.8891 10.7363 13.9907 10.9997 13.9907C11.2631 13.9907 11.5164 13.8891 11.7067 13.7071L17.4137 8.00006L11.7067 2.29306C11.5164 2.11103 11.2631 2.00944 10.9997 2.00944C10.7363 2.00944 10.4831 2.11103 10.2927 2.29306C10.1054 2.48031 10.0001 2.73421 9.99973 2.99906C9.99973 3.26706 10.1037 3.51806 10.2927 3.70706L13.5857 7.00006H3.92773Z"
                        fill="#09445D" />
                    </svg>
                  </div>
                  <p class="fw-500">Microsoft Office</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!----->
        <!----start of overview--------->
        <div id="curriculum" class="pt-50 pb-35">
          <h4 class="text-24 fw-600 capitalize pt-15 mb-25">Curriculum</h4>
          <!------accordion start-------->
          <div class="mt-10">
            <div class="accordion" id="accordionExample">
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingOne">
                  <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne"
                    aria-expanded="true" aria-controls="collapseOne">
                    <div class="btn-title">Section 1: Introduction</div>
                  </button>
                </h2>
                <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                  data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                    <ol class="ol-list">
                      <li>Ut pharetra ipsum</li>
                      <li>Ut pharetra ipsum</li>
                      <li>Ut pharetra ipsum</li>
                    </ol>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingTwo">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                    <div class="btn-title">Section 1: Introduction</div>
                  </button>
                </h2>
                <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                  data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                    <strong>This is the second item's accordion body.</strong>
                    It is hidden by default, until the collapse plugin adds the
                    appropriate classes that we use to style each element. These
                    classes control the overall appearance, as well as the
                    showing and hiding via CSS transitions. You can modify any
                    of this with custom CSS or overriding our default variables.
                    It's also worth noting that just about any HTML can go
                    within the <code>.accordion-body</code>, though the
                    transition does limit overflow.
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingThree">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                    Accordion Item #3
                  </button>
                </h2>
                <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                  data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                    <strong>This is the third item's accordion body.</strong> It
                    is hidden by default, until the collapse plugin adds the
                    appropriate classes that we use to style each element. These
                    classes control the overall appearance, as well as the
                    showing and hiding via CSS transitions. You can modify any
                    of this with custom CSS or overriding our default variables.
                    It's also worth noting that just about any HTML can go
                    within the <code>.accordion-body</code>, though the
                    transition does limit overflow.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!----Acoordion end------->
        </div>
        <!----->

        <!----start of overview--------->
        <div id="target">
          <div class="pt-50">
            <h4 class="text-24 fw-600 capitalize pt-15 mb-25">
              Who This Course For
            </h4>
            <div class="justfiy-between learn pb-30">
              <div class="y-gap-20">
                <div class="d-flex items-center">
                  <div class="d-flex justify-center items-center border-light rounded-full size-20 mr-10 rotate-svg">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="16" viewBox="0 0 21 16" fill="none">
                      <path
                        d="M10.9997 16.0001C10.1987 16.0001 9.44473 15.6881 8.87873 15.1211C8.31273 14.5541 7.99873 13.8001 7.99973 12.9981C7.99973 12.2521 8.27073 12.0001 8.76373 11.0001H3.92773C2.27373 11.0001 0.927734 9.65306 0.927734 8.00006C0.927734 6.34706 2.27373 5.00006 3.92773 5.00006H8.76373C8.26973 4.00006 7.99973 3.74506 7.99973 2.99906C7.99885 2.60489 8.07618 2.21447 8.22723 1.85039C8.37829 1.48632 8.60007 1.15583 8.87973 0.878058C10.0117 -0.253942 11.9877 -0.254941 13.1207 0.879059L20.2417 8.00006L13.1207 15.1211C12.8429 15.4005 12.5124 15.6221 12.1483 15.773C11.7842 15.9239 11.3938 16.0011 10.9997 16.0001ZM3.92773 7.00006C3.67025 7.01158 3.42714 7.12196 3.24901 7.30824C3.07088 7.49452 2.97147 7.74232 2.97147 8.00006C2.97147 8.2578 3.07088 8.5056 3.24901 8.69188C3.42714 8.87815 3.67025 8.98854 3.92773 9.00006H13.5857L10.2927 12.2931C10.1054 12.4803 10.0001 12.7342 9.99973 12.9991C9.99973 13.2681 10.1037 13.5181 10.2927 13.7071C10.4831 13.8891 10.7363 13.9907 10.9997 13.9907C11.2631 13.9907 11.5164 13.8891 11.7067 13.7071L17.4137 8.00006L11.7067 2.29306C11.5164 2.11103 11.2631 2.00944 10.9997 2.00944C10.7363 2.00944 10.4831 2.11103 10.2927 2.29306C10.1054 2.48031 10.0001 2.73421 9.99973 2.99906C9.99973 3.26706 10.1037 3.51806 10.2927 3.70706L13.5857 7.00006H3.92773Z"
                        fill="#09445D" />
                    </svg>
                  </div>
                  <p class="fw-500">Project Controls Engineers</p>
                </div>

                <div class="d-flex items-center">
                  <div class="d-flex justify-center items-center border-light rounded-full size-20 mr-10 rotate-svg">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="16" viewBox="0 0 21 16" fill="none">
                      <path
                        d="M10.9997 16.0001C10.1987 16.0001 9.44473 15.6881 8.87873 15.1211C8.31273 14.5541 7.99873 13.8001 7.99973 12.9981C7.99973 12.2521 8.27073 12.0001 8.76373 11.0001H3.92773C2.27373 11.0001 0.927734 9.65306 0.927734 8.00006C0.927734 6.34706 2.27373 5.00006 3.92773 5.00006H8.76373C8.26973 4.00006 7.99973 3.74506 7.99973 2.99906C7.99885 2.60489 8.07618 2.21447 8.22723 1.85039C8.37829 1.48632 8.60007 1.15583 8.87973 0.878058C10.0117 -0.253942 11.9877 -0.254941 13.1207 0.879059L20.2417 8.00006L13.1207 15.1211C12.8429 15.4005 12.5124 15.6221 12.1483 15.773C11.7842 15.9239 11.3938 16.0011 10.9997 16.0001ZM3.92773 7.00006C3.67025 7.01158 3.42714 7.12196 3.24901 7.30824C3.07088 7.49452 2.97147 7.74232 2.97147 8.00006C2.97147 8.2578 3.07088 8.5056 3.24901 8.69188C3.42714 8.87815 3.67025 8.98854 3.92773 9.00006H13.5857L10.2927 12.2931C10.1054 12.4803 10.0001 12.7342 9.99973 12.9991C9.99973 13.2681 10.1037 13.5181 10.2927 13.7071C10.4831 13.8891 10.7363 13.9907 10.9997 13.9907C11.2631 13.9907 11.5164 13.8891 11.7067 13.7071L17.4137 8.00006L11.7067 2.29306C11.5164 2.11103 11.2631 2.00944 10.9997 2.00944C10.7363 2.00944 10.4831 2.11103 10.2927 2.29306C10.1054 2.48031 10.0001 2.73421 9.99973 2.99906C9.99973 3.26706 10.1037 3.51806 10.2927 3.70706L13.5857 7.00006H3.92773Z"
                        fill="#09445D" />
                    </svg>
                  </div>
                  <p class="fw-500">Planning Engineers</p>
                </div>

                <div class="d-flex items-center">
                  <div class="d-flex justify-center items-center border-light rounded-full size-20 mr-10 rotate-svg">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="16" viewBox="0 0 21 16" fill="none">
                      <path
                        d="M10.9997 16.0001C10.1987 16.0001 9.44473 15.6881 8.87873 15.1211C8.31273 14.5541 7.99873 13.8001 7.99973 12.9981C7.99973 12.2521 8.27073 12.0001 8.76373 11.0001H3.92773C2.27373 11.0001 0.927734 9.65306 0.927734 8.00006C0.927734 6.34706 2.27373 5.00006 3.92773 5.00006H8.76373C8.26973 4.00006 7.99973 3.74506 7.99973 2.99906C7.99885 2.60489 8.07618 2.21447 8.22723 1.85039C8.37829 1.48632 8.60007 1.15583 8.87973 0.878058C10.0117 -0.253942 11.9877 -0.254941 13.1207 0.879059L20.2417 8.00006L13.1207 15.1211C12.8429 15.4005 12.5124 15.6221 12.1483 15.773C11.7842 15.9239 11.3938 16.0011 10.9997 16.0001ZM3.92773 7.00006C3.67025 7.01158 3.42714 7.12196 3.24901 7.30824C3.07088 7.49452 2.97147 7.74232 2.97147 8.00006C2.97147 8.2578 3.07088 8.5056 3.24901 8.69188C3.42714 8.87815 3.67025 8.98854 3.92773 9.00006H13.5857L10.2927 12.2931C10.1054 12.4803 10.0001 12.7342 9.99973 12.9991C9.99973 13.2681 10.1037 13.5181 10.2927 13.7071C10.4831 13.8891 10.7363 13.9907 10.9997 13.9907C11.2631 13.9907 11.5164 13.8891 11.7067 13.7071L17.4137 8.00006L11.7067 2.29306C11.5164 2.11103 11.2631 2.00944 10.9997 2.00944C10.7363 2.00944 10.4831 2.11103 10.2927 2.29306C10.1054 2.48031 10.0001 2.73421 9.99973 2.99906C9.99973 3.26706 10.1037 3.51806 10.2927 3.70706L13.5857 7.00006H3.92773Z"
                        fill="#09445D" />
                    </svg>
                  </div>
                  <p class="fw-500">Delay Analysts</p>
                </div>

                <div class="d-flex items-center">
                  <div class="d-flex justify-center items-center border-light rounded-full size-20 mr-10 rotate-svg">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="16" viewBox="0 0 21 16" fill="none">
                      <path
                        d="M10.9997 16.0001C10.1987 16.0001 9.44473 15.6881 8.87873 15.1211C8.31273 14.5541 7.99873 13.8001 7.99973 12.9981C7.99973 12.2521 8.27073 12.0001 8.76373 11.0001H3.92773C2.27373 11.0001 0.927734 9.65306 0.927734 8.00006C0.927734 6.34706 2.27373 5.00006 3.92773 5.00006H8.76373C8.26973 4.00006 7.99973 3.74506 7.99973 2.99906C7.99885 2.60489 8.07618 2.21447 8.22723 1.85039C8.37829 1.48632 8.60007 1.15583 8.87973 0.878058C10.0117 -0.253942 11.9877 -0.254941 13.1207 0.879059L20.2417 8.00006L13.1207 15.1211C12.8429 15.4005 12.5124 15.6221 12.1483 15.773C11.7842 15.9239 11.3938 16.0011 10.9997 16.0001ZM3.92773 7.00006C3.67025 7.01158 3.42714 7.12196 3.24901 7.30824C3.07088 7.49452 2.97147 7.74232 2.97147 8.00006C2.97147 8.2578 3.07088 8.5056 3.24901 8.69188C3.42714 8.87815 3.67025 8.98854 3.92773 9.00006H13.5857L10.2927 12.2931C10.1054 12.4803 10.0001 12.7342 9.99973 12.9991C9.99973 13.2681 10.1037 13.5181 10.2927 13.7071C10.4831 13.8891 10.7363 13.9907 10.9997 13.9907C11.2631 13.9907 11.5164 13.8891 11.7067 13.7071L17.4137 8.00006L11.7067 2.29306C11.5164 2.11103 11.2631 2.00944 10.9997 2.00944C10.7363 2.00944 10.4831 2.11103 10.2927 2.29306C10.1054 2.48031 10.0001 2.73421 9.99973 2.99906C9.99973 3.26706 10.1037 3.51806 10.2927 3.70706L13.5857 7.00006H3.92773Z"
                        fill="#09445D" />
                    </svg>
                  </div>
                  <p class="fw-500">Project Managers</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!----->
      </section>
      <!-----end of tabs--------->
    </div>
  </div>
</template>
<script>
import curriclum from "../CourseDetails/Curriclum.vue";
import RatingComponent from "../common/RatingComponent.vue";
export default {
  components: {
    curriclum,
    RatingComponent
  },
  data() {
    return {
      direction: localStorage.getItem("direction") || "ltr",
      tabs: [
        { id: "overview", label: "Overview" },
        { id: "curriculum", label: "Curriculum" },
        { id: "requirements", label: "requirements" },
        { id: "target", label: "who this course for" },
      ],
      activeTab: "overview",
    };
  },
  methods: {
    setActiveTab(tabId) {
      this.activeTab = tabId; // Set the active tab
      const targetSection = document.getElementById(tabId); // Find the section by ID
      if (targetSection) {
        targetSection.scrollIntoView({ behavior: "smooth", block: "start" }); // Scroll smoothly
      }
    },
  },
  mounted() {
    window.addEventListener("direction-localstorage-changed", (event) => {
      this.direction = event.detail.storage;
    });
  },
};
</script>
<style lang="scss" scoped>
.accordion-item {
  padding: 18px 5px;
  background: #f9fbfb;
  box-shadow: none;
}

.accordion-body {
  border-top: 1px solid #e6e6e6;
}

.accordion-button::after {
  content: "+";
  color: gray;
  font-size: 20px;
  height: fit-content;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: none;
  width: 30px;
  height: 30px;
}

:lang(en).accordion-button::after {
  margin-right: 0;
  margin-left: auto;
}

:lang(ar).accordion-button::after {
  margin-left: 0;
  margin-right: auto;
}

.accordion-button:not(.collapsed)::after {
  content: "-";
  display: inline-flex;
  justify-content: center;
  align-items: center;
  transform: none;
  color: #fff;
  background: var(--main, #206387);
}

.accordion-button:not(.collapsed) {
  background-color: transparent;
  box-shadow: none !important;
}

.accordion-item {
  margin-bottom: 24px;
  border-radius: 10px;
  background: var(--color-gray-10, #fff);
  box-shadow: 0px 5px 16px 0px rgba(8, 15, 52, 0.06);
  border: none !important;
}

.accordion-button:focus {
  box-shadow: none;
}

.accordion-button {
  .btn-title {
    color: var(--Primary-600, #09445d);
    font-size: 16px;
    font-weight: 500;
  }

  .btn-time {
    color: var(--Neutral-500, #999);
    font-size: 16px;
    font-weight: 400;
    margin-top: 9px;
  }
}

li {
  margin-bottom: 10px;
  color: var(--Neutral-700, #4d4d4d);
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}
</style>
